var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectorLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 196,
    viewBox: "0 0 480 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M471.816 194.742C472.206 195.133 472.84 195.133 473.23 194.742L479.594 188.379C479.984 187.988 479.984 187.355 479.594 186.964C479.203 186.574 478.57 186.574 478.18 186.964L472.523 192.621L466.866 186.964C466.476 186.574 465.842 186.574 465.452 186.964C465.061 187.355 465.061 187.988 465.452 188.379L471.816 194.742ZM2.1311 1.03564C2.1311 0.48336 1.68339 0.0356445 1.1311 0.0356445C0.578819 0.0356445 0.131104 0.48336 0.131104 1.03564H2.1311ZM473.523 194.035V125.295H471.523V194.035H473.523ZM448.523 100.295H25.1311V102.295H448.523V100.295ZM2.1311 77.295V1.03564H0.131104V77.295H2.1311ZM25.1311 100.295C12.4286 100.295 2.1311 89.9976 2.1311 77.295H0.131104C0.131104 91.1021 11.324 102.295 25.1311 102.295V100.295ZM473.523 125.295C473.523 111.488 462.33 100.295 448.523 100.295V102.295C461.225 102.295 471.523 112.592 471.523 125.295H473.523Z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorLine);
export default __webpack_public_path__ + "static/media/connector-line.8cf25beeca7a36987f7b67cdad08372b.svg";
export { ForwardRef as ReactComponent };